export interface IGetFhirActivitiesRequest {
  patientId: string;
  date: Date;
}
